import { render, staticRenderFns } from "./ActivityIframe.vue?vue&type=template&id=3b16c33e&scoped=true"
import script from "./ActivityIframe.vue?vue&type=script&lang=js"
export * from "./ActivityIframe.vue?vue&type=script&lang=js"
import style0 from "./ActivityIframe.vue?vue&type=style&index=0&id=3b16c33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16c33e",
  null
  
)

export default component.exports